import Actions from './page-actions';
import Api from './page-api';
import Collection from './page-collection';
import Model from './page-model';
import reducer from './page-reducer';
import Selectors from './page-selectors';
import sagas from './page-sagas';
import Utils from './page-utils';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'page',
  reducer,
  sagas:     [sagas],
  Selectors,
  Utils,
};
